import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Protected from "../components/Protected";
import ToiPageHeader from "../components/toi/ToiPageHeader";
import { REMITTANCE_SIGNUP } from "../config/constants";
import { REMITTANCE_HOME_PATH, REMITTANCE_NB_HOME_PATH } from "../constants";
import FullScreenSkeleton from "../components/Skeletons/FullScreenSkeleton";
import { checkAuth } from "../libs/auth";
import toiAboundRecipient from "../assets/img/toi/toiAboundRecipient.png";
import toiAboudDarkRecipient from "../assets/img/toi/toiAboudDarkrecipient.png";
import giftIcon from "../assets/img/toi/recipirntGift.png";
// Lazy loaded pages (default exports)
// const Signup = lazy(() => import("../pages/SignUp"));
// const Login = lazy(() => import("../pages/Login"));
const Resetpassword = lazy(() => import("../pages/ResetPassword"));
// const Rewards = lazy(() => import("../pages/accounts/rewards/Rewards"));
const GetApp = lazy(() => import("../pages/GetApp"));
const Plaid = lazy(() => import("../pages/Plaid"));
const ManageAccounts = lazy(() => import("../pages/ManageAccounts"));
const UserForm = lazy(() => import("../pages/UserForm"));
const Withdrawal = lazy(() => import("../pages/Withdrawal"));
const SignupV2 = lazy(() => import("../pages/SignupV2"));
const WillowSignup = lazy(() => import("../pages/WillowSignup"));
const WillowSignupSuccess = lazy(() => import("../pages/WillowSignupSuccess"));
const VerifyOtp = lazy(() => import("../pages/toi/VerifyOtp"));
// const TOILandingPage = lazy(() => import("../pages/toi/TOILandingPage"));
const TOILandingPageA = lazy(
  () => import("../pages/toi/landing/TOILandingPageA"),
);
const TOILandingPageB = lazy(
  () => import("../pages/toi/landing/TOILandingPageB"),
);
const TOILandingPageC = lazy(
  () => import("../pages/toi/landing/TOILandingPageC"),
);
const TOIUpdatedLandingPage = lazy(
  () => import("../pages/toi/landing/TOIUpdatedLandingPage"),
);
const TOIPartnershipLandingPage = lazy(
  () => import("../pages/toi/landing/TOIPartnershipLandingPage"),
);
const RecipientBankDetailsPage = lazy(
  () => import("../pages/toi/RecipientBankDetailsPage"),
);
const TOIAppSignUp = lazy(() => import("../pages/toi/toiAppSignUp"));
const VerifyDetails = lazy(() => import("../pages/VerifyDetails"));
const RemittanceCalcuator = lazy(
  () => import("../pages/Remittance/RemittanceCalculator"),
);
const Reauthenticate = lazy(() => import("../pages/Remittance/Reauthenticate"));
const RemittanceDashboard = lazy(
  () => import("../pages/Remittance/RemittanceDashboard"),
);
const RemittanceRateHome = lazy(
  () => import("../pages/Remittance/RemittanceRateHome"),
);
const CrosswalkSignup = lazy(() => import("../pages/cricbuzz/CrosswalkSignup"));
// const Insomania = lazy(() => import("../pages/cricbuzz/insomania/Insomania"));
// Named export -> map to default for React.lazy
const TOIThemeProvider = lazy(() =>
  import("../pages/toi/TOIThemeProvider").then((module) => ({
    default: module.TOIThemeProvider,
  })),
);
const TOIEmailUpdate = lazy(() => import("../pages/toi/toiEmailUpdate"));
const TOIKycPage = lazy(() => import("../pages/toi/toiKycPage"));

const TOIOnboardingHeader = ({ children }) => {
  const isTOIChannel =
    typeof window !== "undefined" &&
    (window.sessionStorage.getItem("channel") || "") === "TOI";
  const theme =
    (typeof window !== "undefined" && window.sessionStorage.getItem("theme")) ||
    "light";
  const isLight = (theme || "").toLowerCase() === "light";
  const headerLogo = isLight ? toiAboundRecipient : toiAboudDarkRecipient;
  const headerRight = (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontSize: 15,
        fontWeight: 500,
        whiteSpace: "nowrap",
        color: isLight ? "#10b94b" : "#1ed760",
      }}
      aria-label="Claim $50 free"
    >
      <img
        src={giftIcon}
        alt=""
        aria-hidden="true"
        style={{ width: 14, height: 14, objectFit: "contain" }}
      />
      <span>Claim $50 free</span>
    </div>
  );

  return (
    <>
      {isTOIChannel ? (
        <ToiPageHeader
          logo={headerLogo}
          logoAlt="The Times of India x Abound"
          showBackButton={false}
          theme={isLight ? "light" : "dark"}
          rightContent={headerRight}
        />
      ) : null}
      {children}
    </>
  );
};

function RouteController() {
  const isLoggedIn = checkAuth();

  return (
    <Router basename="/getapp">
      <Suspense fallback={<FullScreenSkeleton />}>
        <Routes>
          <Route
            index
            element={
              isLoggedIn ? (
                <Navigate to="/accounts" replace />
              ) : (
                <TOIThemeProvider>
                  <TOIAppSignUp />
                </TOIThemeProvider>
              )
            }
          />
          {/* <Route path="/" element={<Navigate to="/login" />} /> */}
          <Route
            path="/signup"
            element={
              <TOIThemeProvider>
                <TOIAppSignUp />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/signup/v2"
            element={
              <TOIThemeProvider>
                <SignupV2 />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/login"
            element={
              <TOIThemeProvider>
                <TOIAppSignUp />
              </TOIThemeProvider>
            }
          />
          <Route path="/resetPassword" element={<Resetpassword />} />
          <Route path="/user-form" element={<UserForm />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route
            path="/plaid"
            element={
              <Protected>
                <Plaid />
              </Protected>
            }
          />
          <Route
            path="/getApp"
            element={
              <Protected>
                <GetApp />
              </Protected>
            }
          />
          <Route path="/verifyDetails" element={<VerifyDetails />} />
          <Route
            path="/accounts"
            element={
              <Protected>
                <ManageAccounts />
              </Protected>
            }
          />
          <Route
            path="/remittance/calculator"
            element={<RemittanceCalcuator />}
          />
          {/* <Route
          path="/rewards"
          element={
            <Protected>
              <Rewards />
            </Protected>
          }
        ></Route> */}
          <Route path="/willow/forget-password" element={<WillowSignup />} />
          <Route path="/willow/success" element={<WillowSignupSuccess />} />
          <Route path="/crosswalk/signup" element={<CrosswalkSignup />} />
          {/* <Route path="/crosswalk/signup" element={<Insomania />} />
          <Route path="/remittance/toi" element={<Insomania />} /> */}

          <Route
            path="/remittance/signup"
            element={<SignupV2 screenType={REMITTANCE_SIGNUP} />}
          />

          <Route path="/verify-otp" element={<VerifyOtp />} />

          <Route
            path="/onboarding/landing"
            element={
              <TOIThemeProvider>
                <TOIUpdatedLandingPage />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/landing_a"
            element={
              <TOIThemeProvider>
                {/* <TOILandingPageA /> */}
                <TOIUpdatedLandingPage />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/landing_b"
            element={
              <TOIThemeProvider>
                {/* <TOILandingPageB /> */}
                <TOIPartnershipLandingPage />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/landing_c"
            element={
              <TOIThemeProvider>
                <TOILandingPageC />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/landing_updated"
            element={
              <TOIThemeProvider>
                <TOIUpdatedLandingPage />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/recipient-bank-details"
            element={
              <TOIThemeProvider>
                <RecipientBankDetailsPage />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/signup"
            element={
              <TOIThemeProvider>
                <TOIAppSignUp />
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/email-update"
            element={
              <TOIThemeProvider>
                <TOIOnboardingHeader>
                  <TOIEmailUpdate />
                </TOIOnboardingHeader>
              </TOIThemeProvider>
            }
          />
          <Route
            path="/onboarding/kyc"
            element={
              <TOIThemeProvider>
                <TOIOnboardingHeader>
                  <TOIKycPage />
                </TOIOnboardingHeader>
              </TOIThemeProvider>
            }
          />
          <Route
            path="/remittance/bankadd"
            element={
              <Protected>
                <Plaid />
              </Protected>
            }
          />
          <Route
            path="/re-authenticate"
            element={
              <Protected>
                <TOIThemeProvider>
                  <Reauthenticate />
                </TOIThemeProvider>
              </Protected>
            }
          />
          <Route
            path={REMITTANCE_NB_HOME_PATH}
            element={
              <Protected>
                <RemittanceDashboard />
              </Protected>
            }
          />
          <Route path={REMITTANCE_HOME_PATH} element={<RemittanceRateHome />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default RouteController;
